module.exports = __webpack_public_path__ + "fafe9b2f007d66347e60415737178c24.jpg";